import * as React from 'react';
import {Link} from 'src/rerouter/index';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import 'src/components/app.global.css';


const Error410 = ({
  redirectLink,
  buttonText,
  buttonColor,
}: {
  redirectLink?: string | null | undefined;
  buttonText: string;
  buttonColor?: string;
}) => {
  return (
    <EmptyState
      description="This page is no longer valid; instead, use the link provided below."
      imageVariant="data"
    >
      {/* @ts-expect-error - TS2322 - Type '{ children: Element; href: string; }' is not assignable to type 'IntrinsicAttributes & { to?: LocationType | ((arg1: RerouterLocation) => LocationType) | null | undefined; ... 6 more ...; handleExtension?: boolean | undefined; }'. */}
      <Link href={`${redirectLink || ''}`}>
        <Button
          style={{
            backgroundColor: buttonColor,
          }}
          type="primary"
        >
          {buttonText}
        </Button>
      </Link>
    </EmptyState>
  );
};

export default Error410;
